export * from './ClothesHangerIcon';
export * from './ClothesHangerIcon16Light';
export * from './ClothesHangerIcon16Regular';
export * from './ClothesHangerIcon16Solid';
export * from './ClothesHangerIcon20Light';
export * from './ClothesHangerIcon20Regular';
export * from './ClothesHangerIcon20Solid';
export * from './ClothesHangerIcon24Regular';
export * from './ClothesHangerIcon24Solid';
export * from './ClothesHangerIcon32Regular';
export * from './ClothesHangerIcon64Regular';
